<router-outlet *ngIf="router.url.startsWith('/login')"></router-outlet>
<app-panel-router *ngIf="!router.url.startsWith('/login')"></app-panel-router>